import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const ALLERGIES_QUERY_KEY = "allergiesQuery";

export const useAllergiesQuery = (patientUserId) => {
  return useQuery({
    queryKey: [ALLERGIES_QUERY_KEY,patientUserId],
    retry: false,
    queryFn:  getAllAllergies.bind(this,patientUserId),
    placeholderData: [],
    enabled: !!patientUserId
  });
};

export const useAllergyQuery = (id,patientUserId) => {
  return useQuery({
    queryKey: [ALLERGIES_QUERY_KEY,patientUserId],
    retry: false,
    queryFn:getAllAllergies.bind(this, patientUserId),
    placeholderData: [],
    enabled: !!patientUserId,
    select: (allergies) => allergies.filter((a) => a.id === id)[0]
  });
};

const getAllAllergies = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "hrallergiesapi",
    path: "/allergies/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
